import Swiper from "swiper/bundle";

class RelatedSuccessCase {
  constructor(args = { sectionsContainer: document }) {
    this.sectionsContainer = args.sectionsContainer;
    this.sliderGallerySections = Array.from(this.sectionsContainer.getElementsByClassName("related-success-cases"));
    this.swiperInstances = [];
    if (this.sliderGallerySections != null) {
      this.initializeSwiper();
      this.addResizeListener();
    } else {
      return;
    }
  }

  initializeSwiper() {
    const section = this.sliderGallerySections[0];
    if(!section) {
      return;
    }
    this.sliderGallerySections.forEach((section) => {
      const swiperContainer = section.querySelector(".swiper-container");
      
      this.swiperInstances.push(new Swiper(swiperContainer, {
          grabCursor: true,
          loop: false,
          slidesPerView: this.getSlidesPerView(),
          spaceBetween: 20,
          pagination: {
            el: section.querySelector('.swiper-pagination'),
            clickable: true,
          },
          navigation: {
            nextEl: section.querySelector('.swiper-button-next'),
            prevEl: section.querySelector('.swiper-button-prev'),
          },
        }));
    });

  }

  addResizeListener() {
    window.addEventListener('resize', () => {
      if (this.swiperInstances) {
        this.swiperInstances.forEach((instance) => {
          instance.params.slidesPerView = this.getSlidesPerView();
          instance.update();
        });
      }
    });
  }

  getSlidesPerView() {
    const width = window.innerWidth;
    if (width <= 576) {
      return 1.1;
    } else if (width <= 768) {
      return 1.6;
    } else if (width <= 1024) {
      return 2.2;
    } else {
      return 3.2;
    }
  }
}

export default RelatedSuccessCase;
